Drupal.behaviors.cookieConsentOverlay = {
    attach: function (context, settings) {
      function getKlaroConsent() {
        const match = document.cookie.match(/klaro=([^;]+)/);
        if (match) {
          try {
            return JSON.parse(decodeURIComponent(match[1]));
          } catch (e) {
            console.warn('Could not parse Klaro cookie:', e);
          }
        }
        return null;
      }

      function runCookieConsentOverlayLogic() {
        const videoEmbeds = document.querySelectorAll('.external-video-js');
        const klaroConsent = getKlaroConsent();
        const hasThirdPartyConsent = klaroConsent && klaroConsent.third_party_services === true;

        videoEmbeds.forEach(function (videoEmbed) {
          const el = videoEmbed;
          if (!hasThirdPartyConsent) {
            el.classList.add("third-party-video-blocked");
          } else {
            el.classList.remove("third-party-video-blocked");
            // Only append if not already present
            if (!el.querySelector('iframe')) {
              const videoEmbedTemplate = el.querySelector(".embed-video-template");

              if (videoEmbedTemplate && videoEmbedTemplate.content) {
                const clone = videoEmbedTemplate.content.cloneNode(true);
                el.appendChild(clone);
              }
            }
          }
        });
      }

      // Run on attach
      runCookieConsentOverlayLogic();

      // Also run when a video card is clicked
      document.addEventListener('click', function (event) {
        const target = event.target;
        if (target.closest && target.closest('.iframe-container')) {
          runCookieConsentOverlayLogic();
        }

        // IF cm-btn is clicked, reload the page to apply new consent settings
        if (target.closest && target.closest('.cm-btn') && !target.closest('.cm-btn-lern-more')) {
          window.location.reload();
        }
      });
    }
  };